<script setup>
import { HInfoModal, HButton, HRow, HIcon } from '@pixul/hephaestus';
</script>

<template>
  <HInfoModal
    dark
    only-title
    :overflow-parent='overflowParent'
    :parent='parent || injectParent'
    :position='position'
    :scroll-left='scrollLeft'
    :scroll-top='scrollTop'
    timeout='700'
    wait-positionning
  >
    <template #activator>
      <component
        :is='linkComponent'
        :href='path'
        @click='clickOnA'
      >
        <HButton
          :disabled='disabled'
          :outlined='outlined'
          :plain='plain'
          :size="small ? 'small' : 'normal'"
          :type='type'
          :variant='variant'
          @click='click'
        >
          <slot>
            <HRow
              align-items='center'
              :class="contentReverse ? 'row-reverse' : ''"
              gap='8'
            >
              <div
                v-if='loading'
                v-loading:small='loading'
              />
              <HIcon
                v-if='icon && !loading'
                :color='iconColor'
                :icon='icon'
                :read-only='disabled'
                :size='iconSize || (small ? 16 : 20)'
                :type="iconRegular ? 'regular' : 'solid'"
              />
              <p v-if='label'>
                {{ label }}
              </p>
            </HRow>
          </slot>
        </HButton>
      </component>
    </template>
    <template
      v-if='tooltip'
      #default
    >
      <span class='button-tooltip__tooltip'>{{ tooltip }}</span>
    </template>
  </HInfoModal>
</template>

<script>
import { inject } from 'vue';

export default {
  name : 'ButtonTooltip',

  inject : {
    scrollTop  : { default : 0 },
    scrollLeft : { default : 0 }
  },

  props : {
    loading : {
      type    : Boolean,
      default : false
    },

    label : {
      type    : String,
      default : ''
    },

    icon : {
      type    : String,
      default : ''
    },

    outlined : {
      type    : Boolean,
      default : false
    },

    plain : {
      type    : Boolean,
      default : false
    },

    variant : {
      type    : String,
      default : 'default'
    },

    type : {
      type    : String,
      default : 'primary'
    },

    small : {
      type    : Boolean,
      default : false
    },

    disabled : {
      type    : Boolean,
      default : false
    },

    iconRegular : {
      type    : Boolean,
      default : false
    },

    iconSize : {
      type    : [Number, String],
      default : 0
    },

    tooltip : {
      type    : String,
      default : ''
    },

    position : {
      type    : String,
      default : 'top'
    },

    path : {
      type    : String,
      default : ''
    },

    contentReverse : {
      type    : Boolean,
      default : false
    },

    parent : {
      type    : Object,
      default : null
    },

    iconColor : {
      type    : String,
      default : undefined
    },

    overflowParent : {
      type    : Boolean,
      default : false
    }
  },

  emits : ['click'],

  data() {

    return {
      injectParent : null
    };
  },

  computed : {
    linkComponent() {

      if (this.path) {

        return 'a';
      }

      return 'div';
    }
  },

  created() {

    const parent = inject('parent', () => null);
    this.injectParent = parent?._value || null;
  },

  methods : {
    click(e) {

      this.$emit('click', e);
    },

    clickOnA(e) {

      e.preventDefault();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.c-info-modal :deep(.c-info-modal__activator) {
  width: fit-content;
}

.row-reverse {
  flex-direction: row-reverse;
}
</style>
